import { DataService } from "./data.service";
import { HttpClient } from "@/config/httpclient";
import { AxiosRequestConfig } from "axios";

export class ApiService extends DataService {
  // public constructor() {
  // }

  // private _initializeRequestInterceptor = () => {
  //   this.instance.interceptors.request.use(
  //     this._handleRequest,
  //     // this._handleError,
  //   );
  // };

  // private _authInterceptor = () => {

  //   this.instance.interceptors.response.use(response => {
  //     return response.data;
  //   }, error => {
  //       const status = error.response.status;
  //       if (status === 401) {
  //         console.log('Unauthorized');
  //         localStorage.removeItem("token");
  //       }
  //   });
  // }

  // private _handleRequest = (config: AxiosRequestConfig) => {
  //   config.headers['Content-Type'] = 'application/json'
  //   config.headers['Accept'] = 'application/json'
  //   config.headers['Authorization'] = `Bearer ${localStorage.token}`
  //   return config;
  // };

  // eslint-disable-next-line
  getData(url: string, params?: string): Promise<any> {
    return this.instance({
      method: "GET",
      url: url,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  // eslint-disable-next-line
  postData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "POST",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      console.log("psot success");
      console.log({ resp: response });
      return response;
    }).catch((error) => {
      console.log("post fail");

      throw error;
    });
  }

  // eslint-disable-next-line
  putData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "PUT",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  // eslint-disable-next-line
  deleteData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "DELETE",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }
}
